import '@/gf.css'
import Release from './gf/release'

Release.pollForUpdates()
